// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.login {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

div.login div.panel {
  background: rgb(255, 255, 255) !important;
  box-shadow: 0 3px 6px rgba(199, 199, 199, 0.16),
    0 3px 6px rgba(212, 212, 212, 0.23);
}

div.login div.panel.auth div.panel-heading {
  padding-left: 0;
  padding-top: 0;
  padding-right: 0;
  margin-bottom: 15px;
}

div.login div.panel.auth div.panel-heading div.header-logo {
  width: 100%;
}

div.login div.panel div {
  /* position: relative; */
}

.panel-footer {
  background: white !important;
}

div.panel button.btn-primary {
  border: 0;
  font-weight: 600;
  /* height: 50px; */
  /* box-shadow: 0 3px 6px rgba(190, 190, 190, 0.16),
    0 3px 6px rgba(134, 134, 134, 0.23); */
  /* background-color: #f32323 !important; */
}
div.panel button.btn-default {
  background: rgb(252, 252, 252) !important;
  border: 1px solid rgb(221, 221, 221);
  font-weight: 600;
  /* height: 50px; */
  /* box-shadow: 0 3px 6px rgba(190, 190, 190, 0.16),
    0 3px 6px rgba(134, 134, 134, 0.23); */
}

div.panel div input::placeholder {
  /* Firefox, Chrome, Opera */
  color: #d4d4d4;
}

div.panel div input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #d4d4d4;
}

div.panel div input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #d4d4d4;
}

center.otherlogin {
  padding-top: 20px;
}

center.otherlogin a {
  color: #333333;
  font-weight: 600;
  text-decoration: underline;
  opacity: 0.8;
}

center.otherlogin a:hover {
  opacity: 1;
}

label {
  opacity: 0.8;
}

div.alert {
  border-radius: 0;
}

th {
  white-space: nowrap;
}

.panel > .table-responsive {
  padding: 0;
}

.table-bordered {
  margin-bottom: 0;
}

div.loader {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 999;
  width: 200px;
}

.panel-title {
  cursor: pointer;
}

div.content-cont {
  /* height: 100vh;
  overflow-y: auto;
  padding-bottom: 150; */
}

.btn.btn-primary {
  background-color: #f32323 !important;
  border: 0;
}
.btn.csv-btn {
  margin-left: 10px;
  background-color: #f32323 !important;
  border: 0;
  color: #fff;
}
@media only screen and (max-width: 768px) {
  .header-logo span {
    white-space: nowrap;
    overflow: hidden;
  }

  div.header-logo a {
    margin-left: 10px;
  }

  nav.navbar {
    padding-right: 15px;
  }

  ul.navbar-right {
    float: right;
    padding-right: 30px;
    display: flex;
  }

  ul.navbar-right li {
    height: 100%;
  }

  .profile span {
    display: none;
  }
}

.send_sms_btn {
  border: 1px solid #b1cceb;
  padding: 5px;
}

.dil_logo {
  width: 20px;
  height: 20px;
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
/*
@media (min-width: 768px) and (max-width: 1024px) {

  div.header-logo a{
    margin-right: 20px
  }

} */

/*
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/

/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  div.header-logo a{
    margin-right: 20px
  }
} */
.mobitill_logo {
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 20px;
}

.css-26l3qy-menu {
  z-index: 100000 !important;
  overflow-y: auto;
}

.form-control {
  min-height: 38px;
}

.nav-tabs > li > a {
  color: #777;
  font-weight: 999;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
  color: rgb(243, 35, 35);
  cursor: default;
  border: 0;
  border-bottom: 2px solid rgb(243, 35, 35);
  font-weight: 999;
  background-color: transparent;
}

.badge-cleared {
  background-color: #0f881d;
}

.badge-danger {
  background-color: #f32323;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC;uCACqC;AACvC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB;0CACwC;EACxC,0CAA0C;AAC5C;AACA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB;0CACwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;wBAEsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;CAGC;AACD;;;;;;;GAOG;;AAEH;;;CAGC;;AAED;;;;GAIG;AACH;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["div.login {\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\ndiv.login div.panel {\r\n  background: rgb(255, 255, 255) !important;\r\n  box-shadow: 0 3px 6px rgba(199, 199, 199, 0.16),\r\n    0 3px 6px rgba(212, 212, 212, 0.23);\r\n}\r\n\r\ndiv.login div.panel.auth div.panel-heading {\r\n  padding-left: 0;\r\n  padding-top: 0;\r\n  padding-right: 0;\r\n  margin-bottom: 15px;\r\n}\r\n\r\ndiv.login div.panel.auth div.panel-heading div.header-logo {\r\n  width: 100%;\r\n}\r\n\r\ndiv.login div.panel div {\r\n  /* position: relative; */\r\n}\r\n\r\n.panel-footer {\r\n  background: white !important;\r\n}\r\n\r\ndiv.panel button.btn-primary {\r\n  border: 0;\r\n  font-weight: 600;\r\n  /* height: 50px; */\r\n  /* box-shadow: 0 3px 6px rgba(190, 190, 190, 0.16),\r\n    0 3px 6px rgba(134, 134, 134, 0.23); */\r\n  /* background-color: #f32323 !important; */\r\n}\r\ndiv.panel button.btn-default {\r\n  background: rgb(252, 252, 252) !important;\r\n  border: 1px solid rgb(221, 221, 221);\r\n  font-weight: 600;\r\n  /* height: 50px; */\r\n  /* box-shadow: 0 3px 6px rgba(190, 190, 190, 0.16),\r\n    0 3px 6px rgba(134, 134, 134, 0.23); */\r\n}\r\n\r\ndiv.panel div input::placeholder {\r\n  /* Firefox, Chrome, Opera */\r\n  color: #d4d4d4;\r\n}\r\n\r\ndiv.panel div input:-ms-input-placeholder {\r\n  /* Internet Explorer 10-11 */\r\n  color: #d4d4d4;\r\n}\r\n\r\ndiv.panel div input::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: #d4d4d4;\r\n}\r\n\r\ncenter.otherlogin {\r\n  padding-top: 20px;\r\n}\r\n\r\ncenter.otherlogin a {\r\n  color: #333333;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n  opacity: 0.8;\r\n}\r\n\r\ncenter.otherlogin a:hover {\r\n  opacity: 1;\r\n}\r\n\r\nlabel {\r\n  opacity: 0.8;\r\n}\r\n\r\ndiv.alert {\r\n  border-radius: 0;\r\n}\r\n\r\nth {\r\n  white-space: nowrap;\r\n}\r\n\r\n.panel > .table-responsive {\r\n  padding: 0;\r\n}\r\n\r\n.table-bordered {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndiv.loader {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  z-index: 999;\r\n  width: 200px;\r\n}\r\n\r\n.panel-title {\r\n  cursor: pointer;\r\n}\r\n\r\ndiv.content-cont {\r\n  /* height: 100vh;\r\n  overflow-y: auto;\r\n  padding-bottom: 150; */\r\n}\r\n\r\n.btn.btn-primary {\r\n  background-color: #f32323 !important;\r\n  border: 0;\r\n}\r\n.btn.csv-btn {\r\n  margin-left: 10px;\r\n  background-color: #f32323 !important;\r\n  border: 0;\r\n  color: #fff;\r\n}\r\n@media only screen and (max-width: 768px) {\r\n  .header-logo span {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n  }\r\n\r\n  div.header-logo a {\r\n    margin-left: 10px;\r\n  }\r\n\r\n  nav.navbar {\r\n    padding-right: 15px;\r\n  }\r\n\r\n  ul.navbar-right {\r\n    float: right;\r\n    padding-right: 30px;\r\n    display: flex;\r\n  }\r\n\r\n  ul.navbar-right li {\r\n    height: 100%;\r\n  }\r\n\r\n  .profile span {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.send_sms_btn {\r\n  border: 1px solid #b1cceb;\r\n  padding: 5px;\r\n}\r\n\r\n.dil_logo {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n/*\r\n  ##Device = Tablets, Ipads (portrait)\r\n  ##Screen = B/w 768px to 1024px\r\n*/\r\n/*\r\n@media (min-width: 768px) and (max-width: 1024px) {\r\n\r\n  div.header-logo a{\r\n    margin-right: 20px\r\n  }\r\n\r\n} */\r\n\r\n/*\r\n  ##Device = Tablets, Ipads (landscape)\r\n  ##Screen = B/w 768px to 1024px\r\n*/\r\n\r\n/* @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n  div.header-logo a{\r\n    margin-right: 20px\r\n  }\r\n} */\r\n.mobitill_logo {\r\n  width: 100px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  left: 20px;\r\n}\r\n\r\n.css-26l3qy-menu {\r\n  z-index: 100000 !important;\r\n  overflow-y: auto;\r\n}\r\n\r\n.form-control {\r\n  min-height: 38px;\r\n}\r\n\r\n.nav-tabs > li > a {\r\n  color: #777;\r\n  font-weight: 999;\r\n}\r\n\r\n.nav-tabs > li.active > a,\r\n.nav-tabs > li.active > a:focus,\r\n.nav-tabs > li.active > a:hover {\r\n  color: rgb(243, 35, 35);\r\n  cursor: default;\r\n  border: 0;\r\n  border-bottom: 2px solid rgb(243, 35, 35);\r\n  font-weight: 999;\r\n  background-color: transparent;\r\n}\r\n\r\n.badge-cleared {\r\n  background-color: #0f881d;\r\n}\r\n\r\n.badge-danger {\r\n  background-color: #f32323;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
